<!--横向滑动推荐跳转类  view:6  横向滑动推荐新闻类 view：7-->
<template>
    <div class="view7Wrapper">
        <div :class="['tipsGlobalText','tipsWhite']" v-if="tips!==''" v-html="tips">
            {{tips}}
        </div>
        <CrossSlip>
            <BaseCard v-for="(item,ix) in list" :imgUrl="item.imgUrl" :name="item.title"   @on-click="()=>onAsk(item.title,item.title)" :key="`tips-quick-${ix}`" />
        </CrossSlip>
    </div>

</template>

<script>
import CrossSlip from '../Use/cross-slip-wrapper'
import BaseCard from '../Use/base-card'
    export default {
        name: "View7",
        components: {BaseCard,CrossSlip},
        props: {
            list: {
                type: Array,
                default: []
            },
            tips: {
                type: String,
                default: ""
            }
        },
        data() {
            return {};

        },
        methods: {
            onAsk(name,value) {
                this.$emit('on-ask',name,value)
            }

        }
    };
</script>
<style lang="less" scoped>
    @import "../../assets/less/common";
    .view7Wrapper {



    }

</style>
